import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  sample: () => true
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/redux/reducers.js